import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import Hand from "../assets/images/white_hand.png";
import "aos/dist/aos.css";
import { PatentContext } from "../context/PatentContextProvider.js";
import BrandLogo from "../assets/images/logo-removebg-preview.png";
import { ContactUsModal } from "./ContactUsModal.js";
import askJeevesAiImage from "../assets/images/ASK_-_JEEVES-01-removebg-preview (1).png"
import askJeevesRdImage from "../assets/images/Ask_jeeves_rd.png";
import askJeevesIpImage from "../assets/images/ask-jeeves-ip.png";
import askGenevieveImage from "../assets/images/geneieve-logo.png";
import askJeevesGeo from "../assets/images/2 (2) (1).png";
import { useNavigate } from "react-router-dom";
import BbbLogo from "../assets/images/footerlogo (1).png";
// import askJeevesComVideo from "../assets/videos/jeeves.mp4";
import askJeevesComVideo from "../assets/videos/jeeve.mp4";
import askJeevesAiVideo from "../assets/videos/IMG_7527.mp4";
import askGenevieveVideo from "../assets/videos/askgenevieve.mp4";
import { IoNewspaperOutline } from "react-icons/io5";
import { FaRegPlayCircle } from "react-icons/fa";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { LuSend } from "react-icons/lu";

const LandingPage = () => {
  const navigate = useNavigate();
  let substractXaxis = 0;
  let substractXaxis1 = 0;
  let substractXaxisMobile = 0;
  let addYaxis = 0;
  const [openVideo, setOpenVideo] = useState(false);
  const [video, setVideo] = useState();
  const { playMusic, landingPageData, setPatentLicensingModal } = useContext(PatentContext);

  const handleContactUsModal = () => {
    setPatentLicensingModal(true)
  };

  const handleShowVideo = (video) => {
    setOpenVideo(true);
    switch (video) {
      case "ask-jeeves.com":
        setVideo(askJeevesComVideo);
        break;
      case "ask-jeeves.ai":
        setVideo(askJeevesAiVideo);
        break;
      case "askgenevieve.ai":
        setVideo(askGenevieveVideo);
        break;
      default:
        setVideo(askJeevesComVideo);
    }
  };

  const patentClickHandle = (id) => {
    localStorage.setItem("playMusic", JSON.stringify(playMusic));
    switch (id) {
      case "Ask-jeeves.ai":
        window.open("https://ask-jeeves.ai/", "_blank");
        break;
      case "Ask-genevieve.ai":
        window.open("https://ask-genevieve.ai/", "_blank");
        break;
      case "Ask-jeeves-rd.ai":
        window.open("https://ask-jeeves-rd.ai/", "_blank");
        break;
      case "Ask-jeeves-ip.ai":
        window.open("https://ask-jeeves-ip.ai/", "_blank");
        break;
      case "Ask-jeeves-ip.ai":
        window.open("https://ask-jeeves-ip.ai/", "_blank");
        break;
      case "Askjeevesgeo.ai":
        window.open("https://askjeevesgeo.com/", "_blank");
        break;
      case "Mobileboomerang":
        window.open("/Mobileboomerang", "_blank");
        break;
      case "yourfrontoffices.com":
        window.open("/yourfrontoffices", "_blank");
        break;
      case "ippatencompaniesitrust.com":
        window.open("/companies", "_blank");
        break;
      case "Patent attorneys or lawyers":
        window.open("/attornies", "_blank");
        break;
      default:
        <Link to="/" />;
    }
  };


  return (
    <>
      <div className="relative min-h-screen bg-gradient-to-t from-[#680e10e1]/50 via-[#e48284ad] to-[#d76366]/80">
        <div className=" w-full min-h-screen overflow-hidden  overflow-y-auto">
          {/* Header Buttons */}
          <div className="mx-2 mt-2 px-2 flex  items-center md:justify-end lg:gap-5 justify-between">
            <button
              onClick={handleContactUsModal}
              type="button"
              className="
      whitespace-nowrap
      rounded-lg border border-black/10
      bg-[#670E10] px-4 py-3
      text-sm font-semibold text-white
      backdrop-blur-md
      shadow-[0_6px_20px_rgba(0,0,0,0.12)]
      transition-all duration-300
      hover:-translate-y-0.5 hover:bg-[#b74c52]
      hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
      focus:outline-none cursor-pointer">
              <div className="flex justify-center items-center gap-3">
                <LuSend size={15} />
                <span>Drop us a line</span>
              </div>
            </button>
            <div className="px-2">
              <img
                src={BbbLogo}
                className=" backdrop-blur-md
      shadow-[0_6px_20px_rgba(0,0,0,0.12)] h-12"
              />
            </div>
          </div>

          {/* Palm hands */}
          <div className="flex justify-center pt-5 sm:pt-10 mb-[2rem] md:mb-24 ml-4 sm:ml-0 lg:mb-10">
            <img
              src={BrandLogo}
              alt="Ask-Jeeves Logo"
              className=" w-auto object-contain h-[15rem] sm:h-[15rem] md:h-full lg:h-full"
            />
          </div>
          <div className=" w-full flex items-center justify-center">
            <div
              className=" 
    w-[90%] lg:w-[75%]
    grid
    grid-cols-2
    md:grid-cols-5
    gap-y-20 sm:gap-y-0 gap-x-6 items-center justify-center
    place-items-center
    text-white
    z-50"
            >
              <div className={`w-full z-40`}>
                {landingPageData.slice(0, 1).map((patent, index) => {
                  substractXaxis += 450;
                  substractXaxisMobile += 170;
                  addYaxis += 70;

                  return (
                    <div>
                      <div
                        className={
                          "cursor-pointer flex flex-col gap-3 justify-center items-center box-border leading-normal sm:mt-4 md:mt-[5px] lg:mt-[30px] min-w-36"
                        }
                      >
                        <div
                          id="clickableTooltip"
                          className="z-0 flex flex-col justify-center items-center "
                          onClick={() => {
                            patentClickHandle(patent.Palm, index, true);
                          }}
                        >
                          <div className="flex justify-center items-center">
                            <img
                              src={askJeevesAiImage}
                              className="w-20 pt-2 md:w-[120px] lg:w-[120px]"
                              alt="Hand"
                            />
                          </div>
                          <div className="flex justify-center items-center">
                            <img
                              src={Hand}
                              className={` w-20 -m-1 md:w-[100px] lg:w-[120px]`}
                            ></img>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="flex flex-col gap-9 sm:flex-row w-screen  sm:justify-center  h-0 mt-10 sm:mt-0">
                {landingPageData.slice(1, 2).map((patent, index) => {
                  index = index + 3;
                  substractXaxis1 += 150;
                  return (
                    <div>
                      <div
                        className={
                          "cursor-pointer flex flex-col items-center justify-center gap-2 box-border leading-normal sm:mt-[-70px] md:mt-[-88px] lg:mt-[-80px] mt-[-90px] min-w-36"
                        }
                      >
                        <div
                          id="clickableTooltip"
                          className="z-0 flex flex-col justify-center items-center "
                          onClick={() => {
                            patentClickHandle(patent.Palm, index, true);
                          }}
                        >
                          <div className="flex justify-center items-center">
                            <img
                              src={askJeevesRdImage}
                              className="w-20 pt-2 md:w-[100px] lg:w-[100px]"
                              alt="Hand"
                            />
                          </div>
                          <div className="flex justify-center items-center">
                            <img
                              src={Hand}
                              className={` w-20 -m-1 md:w-[100px] lg:w-[120px]`}
                            ></img>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="flex flex-col gap-9 sm:flex-row w-screen sm:justify-center z-40 h-0">
                {landingPageData.slice(2, 3).map((patent, index) => {
                  index = index + 3;
                  substractXaxis1 += 150;
                  return (
                    <div>
                      <div
                        className={
                          "cursor-pointer flex flex-col justify-center items-center gap-2 box-border leading-normal sm:mt-[-60px] mt-[-60px] min-w-36 md:mt-[-76px] lg:mt-[-75px]"
                        }
                      >
                        <div
                          id="clickableTooltip"
                          className="z-0 flex flex-col justify-center items-center "
                          onClick={() => {
                            patentClickHandle(patent.Palm, index, true);
                          }}
                        >
                          <div className="flex justify-center items-center">
                            <img
                              src={askJeevesIpImage}
                              className="w-20 pt-2 md:w-[120px] lg:w-[140px]"
                              alt="Hand"
                            />
                          </div>
                          <div className="flex justify-center items-center">
                            <img
                              src={Hand}
                              className={` w-20 -m-1 md:w-[100px] lg:w-[120px]`}
                            ></img>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="flex flex-col gap-9 sm:flex-row w-screen  sm:justify-center h-0 ">
                {landingPageData.slice(3, 4).map((patent, index) => {
                  index = index + 3;
                  substractXaxis1 += 250;
                  return (
                    <div>
                      <div
                        className={
                          "cursor-pointer flex justify-center items-center gap-2 flex-col box-border leading-normal sm:mt-[-53px] mt-[-60px] min-w-36 md:mt-[-59px] lg:mt-[-70px]"
                        }
                        initial={{ zIndex: -999 }} // Corrected this part
                      >
                        <div
                          id="clickableTooltip"
                          className="z-0 flex flex-col justify-center items-center"
                          onClick={() => {
                            patentClickHandle(patent.Palm, index, true);
                          }}
                        >
                          <div className="flex justify-center items-center">
                            <img
                              src={askGenevieveImage}
                              className="w-20 md:w-[100px] lg:w-[110px]"
                              alt="Hand"
                            />
                          </div>
                          <div className="flex justify-center items-center">
                            <img
                              src={Hand}
                              className={`w-20 md:w-[100px] lg:w-[120px]`}
                            ></img>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="flex flex-col gap-9 sm:flex-row w-screen  sm:justify-center z-40  h-0 mt-10 sm:mt-0">
                {landingPageData.slice(4, 5).map((patent, index) => {
                  index = index + 3;
                  substractXaxis1 += 250;
                  return (
                    <div>
                      <div
                        className={
                          "cursor-pointer flex flex-col justify-center items-center gap-2 box-border leading-normal ml-[11rem] sm:ml-0 sm:mt-[-50px]  mt-[-60px] min-w-36 md:mt-[-58px] lg:mt-[-70px]"
                        }
                      >
                        <div
                          id="clickableTooltip"
                          className="z-0 flex flex-col justify-center items-center"
                          onClick={() => {
                            patentClickHandle(patent.Palm, index, true);
                          }}
                        >
                          <div className="flex justify-center items-center">
                            <img
                              src={askJeevesGeo}
                              className="w-20 md:w-[110px] lg:w-[130px]"
                              alt="Hand"
                            />
                          </div>
                          <div className="flex justify-center items-center">
                            <img
                              src={Hand}
                              className={`w-20 md:w-[100px] lg:w-[120px]`}
                            ></img>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* interaction Buttons */}
          <div className=" mt-20  md:mt-10 mb-16 sm:mb-0 lg:mb-20">
            <div className=" sm:mx-2 mt-2 flex flex-wrap w-full sm:flex-nowrap justify-center gap-7">
              <div>
                <button
                  onClick={() => handleShowVideo("ask-jeeves.com")}
                  type="button"
                  className="
      whitespace-nowrap
      rounded-lg border border-black/10
      bg-[#670E10] px-5 sm:px-4 py-3.5 ml-1 sm:ml-0
      text-sm font-semibold text-white
      backdrop-blur-md
      shadow-[0_6px_20px_rgba(0,0,0,0.12)]
      transition-all duration-300
      hover:-translate-y-0.5 hover:bg-[#b74c52]
      hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
      focus:outline-none cursor-pointer
    "
                >
                  <div className="flex justify-center items-center gap-2">
                    <FaRegPlayCircle size={18} />

                    <span className="text-xs md:text-sm">Jeeves from the past to the Future & Beyond</span>
                  </div>
                </button>
              </div>
              <div>
                <button
                  onClick={() => navigate("/seven-pillars")}
                  type="button"
                  className="
      whitespace-nowrap
      rounded-lg border border-black/10
      bg-[#670E10] px-4 py-3.5
      text-sm font-semibold text-white
      backdrop-blur-md
      shadow-[0_6px_20px_rgba(0,0,0,0.12)]
      transition-all duration-300
      hover:-translate-y-0.5 hover:bg-[#b74c52]
      hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
      focus:outline-none cursor-pointer
    "
                >
                  <div className="flex justify-center items-center gap-2">
                    <IoNewspaperOutline size={18} />
                    <span>O'Hanlon Center of Excellence</span>
                  </div>
                </button>
              </div>
              <Menu as="div" className="relative inline-block z-40">
                <MenuButton className="inline-flex w-full justify-center group  group relative items-center gap-2 whitespace-nowrap pl-7
      rounded-lg border border-black/10
      bg-[#670E10] px-4 py-3.5
      text-sm font-semibold text-white
      backdrop-blur-md
      shadow-[0_6px_20px_rgba(0,0,0,0.12)]
      transition-all duration-300
      hover:-translate-y-0.5 hover:bg-[#b74c52]
      hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
      focus:outline-none cursor-pointer">
                  Press Release
                  <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                </MenuButton>

                <MenuItems
                  transition
                  className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md  bg-[#670E10]/100 outline-[#670E10]/100 transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
                >
                  <div className="py-1">
                    <MenuItem>
                      <a
                        href="https://investorshangout.com/kenneth-ohanlon-pioneering-the-future-of-digital-innovation-509688-/"
                        target="_blank"
                        className="block px-1 py-2 text-sm text-white data-focus:bg-white/5 data-focus:text-white data-focus:outline-hidden
                    hover:bg-white/15"
                      >
                        Pioneering the Future of Digital Innovation - Investors Hangout
                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="https://sg.finance.yahoo.com/news/inner-circle-acknowledges-kenneth-ohanlon-172800269.html?guccounter=1"
                        target="_blank"
                        className="block px-1 py-2 text-sm text-white data-focus:bg-white/5 data-focus:text-white data-focus:outline-hidden hover:bg-white/15"
                      >
                        The Inner Circle acknowledges Kenneth O'Hanlon
                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="https://feature.marquiswhoswho.com/MWW_WSJ_Western_February12_2026"
                        target="_blank"
                        className="block px-1 py-2 text-sm text-white data-focus:bg-white/5 data-focus:text-white data-focus:outline-hidden hover:bg-white/15"
                      >
                        Marquis who's who
                      </a>
                    </MenuItem>
                  </div>
                </MenuItems>
              </Menu>
            </div>
          </div>
        </div>
        <footer className="absolute bottom-0 w-full bg-white/15 text-center py-3">
          © 2026 AskJeeves. All Rights Reserved
        </footer>
        {/* Video on modal */}
        {openVideo && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
            onClick={() => setOpenVideo(false)}
          >
            <div
              className="relative mx-4 w-full max-w-6xl rounded-2xl border border-[#121315]/40 bg-[#121315]/30 backdrop-blur-md shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close */}
              <button
                onClick={() => setOpenVideo(false)}
                aria-label="Close video"
                className="absolute -right-4 -top-4 flex h-9 w-9 items-center justify-center rounded-full bg-[#b54950] text-white font-bold shadow-lg transition hover:scale-105 cursor-pointer"
              >
                ✕
              </button>

              {/* Video */}
              <video
                src={video}
                controls
                autoPlay
                className="w-full rounded-2xl"
              />
            </div>
          </div>
        )}
        <ContactUsModal />
      </div>
    </>
  );
};

export default LandingPage;
